import { AppServerAPI } from '@sdbn/common';
import { AreaGateReference, GateKeepingCandidate } from './../../../../gate-keeping.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';

@Component({
    selector: 'app-gate-keeper-control-find-element-by-query',
    templateUrl: './gkc-find-element-by-query.component.html',
    styleUrls: ['./gkc-find-element-by-query.component.scss'],
    standalone: false
})
export class GKCFindElementByQueryComponent {

  @Input() areaGateReference: AreaGateReference;

  @Output() selectionChanged = new EventEmitter<Array<GateKeepingCandidate>>();

  formGroup = new FormGroup({
    query: new FormControl('', []),
  });

  constructor(
    private appServerAPI: AppServerAPI
  ) { }

  executeSearch() {
    const searchParams = {
      query: this.formGroup.controls.query.value,
      gateId: this.areaGateReference.id,
      direction: this.areaGateReference.direction
    };
    this.appServerAPI.execute<Array<GateKeepingCandidate>>('/tmc-common/gate-keeper-app/handleQuery', searchParams).subscribe(response => {
      let candidates = new Array<GateKeepingCandidate>();
      for (let entry of response) {
        candidates.push(new GateKeepingCandidate(entry));
      }
      this.selectionChanged.emit(candidates);
    });
  }
}
